import * as React from "react";
import { useState, useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import Button from "@mui/material/Button";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import Grid from "@mui/material/Grid2";
import { Alert, Box, Container, Stack } from "@mui/material";
import TextField from "@mui/material/TextField";
import { ApiService } from "../ApiService";
import Autocomplete from "@mui/material/Autocomplete";
import Snackbar from "@mui/material/Snackbar";

export const ModalEditClienteEmpresa = ({ clienteEmpresa, isOpen, onClose, keyBranch, onClientUpdated, action }) => {
	const [isEditLoading, setIsEditLoading] = useState(false);
	const [editData, setEditData] = useState({});
	const [snackBarOpen, setSnackBarOpen] = useState(false);
	const [snackBarMessage, setSnackBarMessage] = useState("");
	const [snackBarType, setSnackBarType] = useState("");
	//TODO move this to an export
	const countriese = [
		{ nameCode: "af", dialCode: "93", name: "+93" },
		{ nameCode: "al", dialCode: "355", name: "+355" },
		{ nameCode: "de", dialCode: "49", name: "+49" },
		{ nameCode: "ad", dialCode: "376", name: "+376" },
		{ nameCode: "ao", dialCode: "244", name: "+244" },
		{ nameCode: "ag", dialCode: "1", name: "+1" },
		{ nameCode: "sa", dialCode: "966", name: "+966" },
		{ nameCode: "dz", dialCode: "213", name: "+213" },
		{ nameCode: "ar", dialCode: "54", name: "+54" },
		{ nameCode: "am", dialCode: "374", name: "+374" },
		{ nameCode: "au", dialCode: "61", name: "+61" },
		{ nameCode: "at", dialCode: "43", name: "+43" },
		{ nameCode: "az", dialCode: "994", name: "+994" },
		{ nameCode: "bs", dialCode: "1", name: "+1" },
		{ nameCode: "bd", dialCode: "880", name: "+880" },
		{ nameCode: "bb", dialCode: "1", name: "+1" },
		{ nameCode: "bh", dialCode: "973", name: "+973" },
		{ nameCode: "be", dialCode: "32", name: "+32" },
		{ nameCode: "bz", dialCode: "501", name: "+501" },
		{ nameCode: "bj", dialCode: "229", name: "+229" },
		{ nameCode: "by", dialCode: "375", name: "+375" },
		{ nameCode: "mm", dialCode: "95", name: "+95" },
		{ nameCode: "bo", dialCode: "591", name: "+591" },
		{ nameCode: "ba", dialCode: "387", name: "+387" },
		{ nameCode: "bw", dialCode: "267", name: "+267" },
		{ nameCode: "br", dialCode: "55", name: "+55" },
		{ nameCode: "bn", dialCode: "673", name: "+673" },
		{ nameCode: "bg", dialCode: "359", name: "+359" },
		{ nameCode: "bf", dialCode: "226", name: "+226" },
		{ nameCode: "bi", dialCode: "257", name: "+257" },
		{ nameCode: "bt", dialCode: "975", name: "+975" },
		{ nameCode: "cv", dialCode: "238", name: "+238" },
		{ nameCode: "kh", dialCode: "855", name: "+855" },
		{ nameCode: "cm", dialCode: "237", name: "+237" },
		{ nameCode: "ca", dialCode: "1", name: "+1" },
		{ nameCode: "qa", dialCode: "974", name: "+974" },
		{ nameCode: "td", dialCode: "235", name: "+235" },
		{ nameCode: "cl", dialCode: "56", name: "+56" },
		{ nameCode: "cn", dialCode: "86", name: "+86" },
		{ nameCode: "cy", dialCode: "357", name: "+357" },
		{ nameCode: "va", dialCode: "39", name: "+39" },
		{ nameCode: "co", dialCode: "57", name: "+57" },
		{ nameCode: "km", dialCode: "269", name: "+269" },
		{ nameCode: "kp", dialCode: "850", name: "+850" },
		{ nameCode: "kr", dialCode: "82", name: "+82" },
		{ nameCode: "ci", dialCode: "225", name: "+225" },
		{ nameCode: "cr", dialCode: "506", name: "+506" },
		{ nameCode: "hr", dialCode: "385", name: "+385" },
		{ nameCode: "cu", dialCode: "53", name: "+53" },
		{ nameCode: "dk", dialCode: "45", name: "+45" },
		{ nameCode: "dm", dialCode: "1", name: "+1" },
		{ nameCode: "ec", dialCode: "593", name: "+593" },
		{ nameCode: "eg", dialCode: "20", name: "+20" },
		{ nameCode: "sv", dialCode: "503", name: "+503" },
		{ nameCode: "ae", dialCode: "971", name: "+971" },
		{ nameCode: "er", dialCode: "291", name: "+291" },
		{ nameCode: "sk", dialCode: "421", name: "+421" },
		{ nameCode: "si", dialCode: "386", name: "+386" },
		{ nameCode: "es", dialCode: "34", name: "+34" },
		{ nameCode: "us", dialCode: "1", name: "+1" },
		{ nameCode: "ee", dialCode: "372", name: "+372" },
		{ nameCode: "et", dialCode: "251", name: "+251" },
		{ nameCode: "ph", dialCode: "63", name: "+63" },
		{ nameCode: "fi", dialCode: "358", name: "+358" },
		{ nameCode: "fj", dialCode: "679", name: "+679" },
		{ nameCode: "fr", dialCode: "33", name: "+33" },
		{ nameCode: "ga", dialCode: "241", name: "+241" },
		{ nameCode: "gm", dialCode: "220", name: "+220" },
		{ nameCode: "ge", dialCode: "995", name: "+995" },
		{ nameCode: "gh", dialCode: "233", name: "+233" },
		{ nameCode: "gd", dialCode: "1", name: "+1" },
		{ nameCode: "gr", dialCode: "30", name: "+30" },
		{ nameCode: "gt", dialCode: "502", name: "+502" },
		{ nameCode: "gy", dialCode: "592", name: "+592" },
		{ nameCode: "gn", dialCode: "224", name: "+224" },
		{ nameCode: "gq", dialCode: "240", name: "+240" },
		{ nameCode: "gw", dialCode: "245", name: "+245" },
		{ nameCode: "ht", dialCode: "509", name: "+509" },
		{ nameCode: "hn", dialCode: "504", name: "+504" },
		{ nameCode: "hu", dialCode: "36", name: "+36" },
		{ nameCode: "in", dialCode: "91", name: "+91" },
		{ nameCode: "id", dialCode: "62", name: "+62" },
		{ nameCode: "iq", dialCode: "964", name: "+964" },
		{ nameCode: "ir", dialCode: "98", name: "+98" },
		{ nameCode: "ie", dialCode: "353", name: "+353" },
		{ nameCode: "is", dialCode: "354", name: "+354" },
		{ nameCode: "mh", dialCode: "692", name: "+692" },
		{ nameCode: "sb", dialCode: "677", name: "+677" },
		{ nameCode: "il", dialCode: "972", name: "+972" },
		{ nameCode: "it", dialCode: "39", name: "+39" },
		{ nameCode: "jm", dialCode: "1", name: "+1" },
		{ nameCode: "jp", dialCode: "81", name: "+81" },
		{ nameCode: "jo", dialCode: "962", name: "+962" },
		{ nameCode: "kz", dialCode: "7", name: "+7" },
		{ nameCode: "ke", dialCode: "254", name: "+254" },
		{ nameCode: "kg", dialCode: "996", name: "+996" },
		{ nameCode: "ki", dialCode: "686", name: "+686" },
		{ nameCode: "kw", dialCode: "965", name: "+965" },
		{ nameCode: "la", dialCode: "856", name: "+856" },
		{ nameCode: "ls", dialCode: "266", name: "+266" },
		{ nameCode: "lv", dialCode: "371", name: "+371" },
		{ nameCode: "lb", dialCode: "961", name: "+961" },
		{ nameCode: "lr", dialCode: "231", name: "+231" },
		{ nameCode: "ly", dialCode: "218", name: "+218" },
		{ nameCode: "li", dialCode: "423", name: "+423" },
		{ nameCode: "lt", dialCode: "370", name: "+370" },
		{ nameCode: "lu", dialCode: "352", name: "+352" },
		{ nameCode: "mk", dialCode: "389", name: "+389" },
		{ nameCode: "mg", dialCode: "261", name: "+261" },
		{ nameCode: "my", dialCode: "60", name: "+60" },
		{ nameCode: "mw", dialCode: "265", name: "+265" },
		{ nameCode: "mv", dialCode: "960", name: "+960" },
		{ nameCode: "ml", dialCode: "223", name: "+223" },
		{ nameCode: "mt", dialCode: "356", name: "+356" },
		{ nameCode: "ma", dialCode: "212", name: "+212" },
		{ nameCode: "mu", dialCode: "230", name: "+230" },
		{ nameCode: "mr", dialCode: "222", name: "+222" },
		{ nameCode: "mx", dialCode: "52", name: "+52" },
		{ nameCode: "fm", dialCode: "691", name: "+691" },
		{ nameCode: "md", dialCode: "373", name: "+373" },
		{ nameCode: "mc", dialCode: "377", name: "+377" },
		{ nameCode: "mn", dialCode: "976", name: "+976" },
		{ nameCode: "me", dialCode: "382", name: "+382" },
		{ nameCode: "mz", dialCode: "258", name: "+258" },
		{ nameCode: "na", dialCode: "264", name: "+264" },
		{ nameCode: "nr", dialCode: "674", name: "+674" },
		{ nameCode: "np", dialCode: "977", name: "+977" },
		{ nameCode: "ni", dialCode: "505", name: "+505" },
		{ nameCode: "ne", dialCode: "227", name: "+227" },
		{ nameCode: "ng", dialCode: "234", name: "+234" },
		{ nameCode: "no", dialCode: "47", name: "+47" },
		{ nameCode: "nz", dialCode: "64", name: "+64" },
		{ nameCode: "om", dialCode: "968", name: "+968" },
		{ nameCode: "nl", dialCode: "31", name: "+31" },
		{ nameCode: "pk", dialCode: "92", name: "+92" },
		{ nameCode: "pw", dialCode: "680", name: "+680" },
		{ nameCode: "pa", dialCode: "507", name: "+507" },
		{ nameCode: "pg", dialCode: "675", name: "+675" },
		{ nameCode: "py", dialCode: "595", name: "+595" },
		{ nameCode: "pe", dialCode: "51", name: "+51" },
		{ nameCode: "pl", dialCode: "48", name: "+48" },
		{ nameCode: "pt", dialCode: "351", name: "+351" },
		{ nameCode: "gb", dialCode: "44", name: "+44" },
		{ nameCode: "cf", dialCode: "236", name: "+236" },
		{ nameCode: "cz", dialCode: "420", name: "+420" },
		{ nameCode: "cg", dialCode: "242", name: "+242" },
		{ nameCode: "cd", dialCode: "243", name: "+243" },
		{ nameCode: "do", dialCode: "1", name: "+1" },
		{ nameCode: "za", dialCode: "27", name: "+27" },
		{ nameCode: "rw", dialCode: "250", name: "+250" },
		{ nameCode: "ro", dialCode: "40", name: "+40" },
		{ nameCode: "ru", dialCode: "7", name: "+7" },
		{ nameCode: "ws", dialCode: "685", name: "+685" },
		{ nameCode: "kn", dialCode: "1", name: "+1" },
		{ nameCode: "sm", dialCode: "378", name: "+378" },
		{ nameCode: "vc", dialCode: "1", name: "+1" },
		{ nameCode: "lc", dialCode: "1", name: "+1" },
		{ nameCode: "st", dialCode: "239", name: "+239" },
		{ nameCode: "sn", dialCode: "221", name: "+221" },
		{ nameCode: "rs", dialCode: "381", name: "+381" },
		{ nameCode: "sc", dialCode: "248", name: "+248" },
		{ nameCode: "sl", dialCode: "232", name: "+232" },
		{ nameCode: "sg", dialCode: "65", name: "+65" },
		{ nameCode: "sy", dialCode: "963", name: "+963" },
		{ nameCode: "so", dialCode: "252", name: "+252" },
		{ nameCode: "lk", dialCode: "94", name: "+94" },
		{ nameCode: "sz", dialCode: "268", name: "+268" },
		{ nameCode: "sd", dialCode: "249", name: "+249" },
		{ nameCode: "ss", dialCode: "211", name: "+211" },
		{ nameCode: "se", dialCode: "46", name: "+46" },
		{ nameCode: "ch", dialCode: "41", name: "+41" },
		{ nameCode: "sr", dialCode: "597", name: "+597" },
		{ nameCode: "th", dialCode: "66", name: "+66" },
		{ nameCode: "tz", dialCode: "255", name: "+255" },
		{ nameCode: "tj", dialCode: "992", name: "+992" },
		{ nameCode: "tl", dialCode: "670", name: "+670" },
		{ nameCode: "tg", dialCode: "228", name: "+228" },
		{ nameCode: "to", dialCode: "676", name: "+676" },
		{ nameCode: "tt", dialCode: "1", name: "+1" },
		{ nameCode: "tn", dialCode: "216", name: "+216" },
		{ nameCode: "tm", dialCode: "993", name: "+993" },
		{ nameCode: "tr", dialCode: "90", name: "+90" },
		{ nameCode: "tv", dialCode: "688", name: "+688" },
		{ nameCode: "ua", dialCode: "380", name: "+380" },
		{ nameCode: "ug", dialCode: "256", name: "+256" },
		{ nameCode: "uy", dialCode: "598", name: "+598" },
		{ nameCode: "uz", dialCode: "998", name: "+998" },
		{ nameCode: "vu", dialCode: "678", name: "+678" },
		{ nameCode: "ve", dialCode: "58", name: "+58" },
		{ nameCode: "vn", dialCode: "84", name: "+84" },
		{ nameCode: "ye", dialCode: "967", name: "+967" },
		{ nameCode: "dj", dialCode: "253", name: "+253" },
		{ nameCode: "zm", dialCode: "260", name: "+260" },
		{ nameCode: "zw", dialCode: "263", name: "+263" },
	];

	// Find country by code
	const findCountryByCode = (code) => {
		return countriese.find((c) => parseInt(c.dialCode) === code) || countriese.find((c) => c.nameCode === "bo"); // Default to Bolivia if not found
	};

	// Initialize state with the clienteEmpresa data
	const [selectedCountry, setSelectedCountry] = useState(findCountryByCode(clienteEmpresa.codePhone || 591));

	useEffect(() => {
		if (Object.keys(clienteEmpresa).length === 0) {
			return;
		}
		setEditData(clienteEmpresa);

		// Update the selected country when clienteEmpresa changes
		if (clienteEmpresa.codePhone) {
			setSelectedCountry(findCountryByCode(clienteEmpresa.codePhone));
		}
	}, [clienteEmpresa]);

	const handleDataChange = (field, value) => {
		if (action == "read") return;

		setEditData((prev) => {
			const updated = {
				...prev,
				[field]: value,
			};

			// Update fullName whenever first_name or last_name changes
			if (field === "first_name" || field === "last_name") {
				updated.fullName =
					`${field === "first_name" ? value : updated.first_name || ""} ${field === "last_name" ? value : updated.last_name || ""}`.trim();
			}

			return updated;
		});
	};
	const editCliente = async () => {
		setIsEditLoading(true);
		try {
			const originalData = clienteEmpresa;
			const changedData = { key_client: editData.key_client };
			for (const key of Object.keys(editData)) {
				if (editData[key] !== originalData[key] && key !== "key_client") {
					if (key === "codePhone") {
						changedData["code_phone"] = editData[key];
					} else if (key === "phone") {
						changedData["phone_number"] = editData[key];
					} else {
						changedData[key] = editData[key];
					}
				}
			}
			const url = `api/company/clients/update?key_branch=${keyBranch}`;
			const payload = {
				method: "PUT",
				body: JSON.stringify(changedData),
			};
			const response = await ApiService.fetchData(url, payload);
			if (response?.code === 200) {
				const updatedClient = {
					...clienteEmpresa,
					...editData,
					// Make sure the fullName is properly set with the concatenated name values
					fullName:
						`${editData.first_name || clienteEmpresa.first_name} ${editData.last_name || clienteEmpresa.last_name}`.trim(),
					// Make sure we use the correct property name in the returned object
					code_phone: editData.codePhone || clienteEmpresa.codePhone,
				};
				onClientUpdated(updatedClient);
				setSnackBarMessage(response.message);
				setSnackBarType("success");
				setSnackBarOpen(true);
				onClose();
				return;
			}
			setSnackBarType("error");
			setSnackBarMessage(response.message);
			setSnackBarOpen(true);
			setIsEditLoading(false);
			onClose();
		} catch (error) {
			console.error("Error saving data:", error);
		} finally {
			setIsEditLoading(false);
		}
	};
	return (
		<>
			<Dialog disableEscapeKeyDown={true} open={isOpen} onClose={onClose} maxWidth={"md"} fullWidth>
				<DialogContent dividers={true}>
					<DialogTitle>{`${action == "read" ? "Mostrar" : "Editar"} datos de ${clienteEmpresa.fullName}`}</DialogTitle>
					<Container disableGutters={true} sx={{ justifyContent: "center", alignItems: "center" }}>
						<Grid container spacing={2}>
							<Grid size={6} md={6}>
								<TextField
									fullWidth={true}
									size={"small"}
									label={"Nombre/Razón Social"}
									required={true}
									value={editData.first_name || ""}
									onChange={(e) => handleDataChange("first_name", e.target.value)}></TextField>
							</Grid>
							<Grid size={6} md={6}>
								<TextField
									fullWidth={true}
									size={"small"}
									label={"Apellido"}
									value={editData.last_name || ""}
									onChange={(e) => handleDataChange("last_name", e.target.value)}></TextField>
							</Grid>
							<Grid size={6} md={6}>
								<Stack direction={"row"} spacing={0.5} alignItems={"center"}>
									<Autocomplete
										size="small"
										sx={{
											"width": "50%",
											"& .MuiInputBase-root": {
												backgroundColor: "#fff",
												fontSize: 12,
											},
										}}
										label={"Codigo de pais"}
										options={countriese}
										value={selectedCountry}
										onChange={(event, newValue) => {
											setSelectedCountry(newValue);
											// Handle the case when newValue is null (input cleared)
											if (newValue) {
												handleDataChange("codePhone", parseInt(newValue.dialCode));
											} else {
												// Use a default value or null if input is cleared
												handleDataChange("codePhone", 591); // Default to Bolivia country code
											}
										}}
										getOptionLabel={(option) => `+ ${option.dialCode}`}
										filterOptions={(options, { inputValue }) => {
											const inputLower = inputValue.toLowerCase();
											return options.filter(
												(option) =>
													option.nameCode.toLowerCase().includes(inputLower) ||
													option.dialCode.includes(inputLower)
											);
										}}
										renderOption={(props, option) => (
											<Box
												component="li"
												sx={{ "& > img": { mr: 2, flexShrink: 0 }, "width": 200 }}
												{...props}>
												<img
													loading="lazy"
													width="15"
													srcSet={`https://flagcdn.com/w40/${option.nameCode.toLowerCase()}.png 2x`}
													src={`https://flagcdn.com/w20/${option.nameCode.toLowerCase()}.png`}
													alt=""
												/>
												({option.nameCode}) {option.name}
											</Box>
										)}
										renderInput={(params) => (
											<TextField
												label={"Codigo de pais"}
												{...params}
												slotProps={{
													htmlInput: {
														...params.inputProps,
														autoComplete: "new-password",
													},
												}}
												// Aquí agregamos la bandera de selectedCountry como adorno
												InputProps={{
													...params.InputProps,
													startAdornment: selectedCountry ? (
														<>
															<img
																loading="lazy"
																width="18"
																style={{ marginRight: 8 }}
																src={`https://flagcdn.com/w20/${selectedCountry.nameCode.toLowerCase()}.png`}
																srcSet={`https://flagcdn.com/w40/${selectedCountry.nameCode.toLowerCase()}.png 2x`}
																alt=""
															/>
															{params.InputProps.startAdornment}
														</>
													) : (
														params.InputProps.startAdornment
													),
												}}
											/>
										)}
									/>
									<TextField
										sx={{ width: "50%" }}
										size={"small"}
										label={"Telefono"}
										value={editData.phone || ""}
										onChange={(e) => handleDataChange("phone", e.target.value)}></TextField>
								</Stack>
							</Grid>
							<Grid size={6} md={6}>
								<TextField
									fullWidth={true}
									size={"small"}
									label={"CI/NIT"}
									value={editData.dni || ""}
									onChange={(e) => handleDataChange("dni", e.target.value)}></TextField>
							</Grid>
						</Grid>
					</Container>
				</DialogContent>
				{
					action == "edit" ? (<DialogActions>
						<Button onClick={onClose} disabled={isEditLoading}>
							Cancelar
						</Button>
						<Button
							loading={isEditLoading}
							variant={"contained"}
							onClick={editCliente}
							color="primary"
							disabled={isEditLoading}>
							Guardar
						</Button>
					</DialogActions>) : <br></br>
				}
			</Dialog>
			<Snackbar
				anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
				open={snackBarOpen}
				autoHideDuration={2600}
				onClose={() => setSnackBarOpen(false)}>
				<Alert
					onClose={() => setSnackBarOpen(false)}
					severity={snackBarType}
					variant="filled"
					sx={{ width: "100%" }}>
					{snackBarMessage}
				</Alert>
			</Snackbar>
		</>
	);
};
